module.exports = {"370303001":"车站街道","370303002":"公园街道","370303003":"湖田街道","370303004":"和平街道","370303005":"科苑街道","370303006":"体育场街道","370303008":"四宝山街道","370303100":"马尚镇","370303101":"南定镇","370303102":"沣水镇","370303104":"傅家镇","370303105":"中埠镇","370303107":"房镇镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370303.json
// module id = 1271
// module chunks = 0